import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCategories = (categories) => {
  return {
    type: actionTypes.SET_CATEGORIES,
    payload: categories
  }
}
